export const EPISODES_ENTER_NODE = "EPISODES_ENTER_NODE";
export const EPISODES_EXIT_PATHWAY = "EPISODES_EXIT_PATHWAY";
export const EPISODES_UPLOAD_SUCCESS = "EPISODES_UPLOAD_SUCCESS";
export const EPISODES_RECORD_OUTCOME = "EPISODES_RECORD_OUTCOME";
